var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoinMember = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M9 14a2 2 0 0 0 2 2h2.257a1.743 1.743 0 0 0 .55-3.397l-3.615-1.206A1.743 1.743 0 0 1 10.743 8H13a2 2 0 0 1 2 2m-3-3.5v11"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
})));
export default SvgCoinMember;